import { Badge } from "@/components/ui/badge";

interface ProjectOverdueBadgeProps {
  hasFinancialAccess?: boolean;
  hasOverdueInstallments?: boolean;
}

export function ProjectOverdueBadge({
  hasFinancialAccess,
  hasOverdueInstallments,
}: ProjectOverdueBadgeProps) {
  if (!hasFinancialAccess || !hasOverdueInstallments) return null;

  return (
    <Badge variant="destructive" className="rounded-none">
      Pagamento atrasado
    </Badge>
  );
}
